import React from 'react';
import {camelOrSnakeField} from "../../../ReduxStore/Helpers/transformObject";

/**
 * Selector for the "ProductUnique", where two different products
 * are available at the same product code (like UM1).
 *
 * ex, Ford F150 2009 Standard Cab 1Pc Front -
 *    available in bench/bucket seat configs.
 */
export default function ProductUniqueOption({unique, callbacks, cartItem}) {

  const handleChange = (evt) => {
    let pn = camelOrSnakeField(cartItem, 'extended_part_number');
    if (pn) {
      // FIXME snake_case
      callbacks.selectItemOption(pn, "product_unique",
        {id: appCode, name: uniqueName});
    } else {
      alert("no part number")
    }
  }

  // Name of the ProductUnique, will be communicated to parent.
  // ex. "Convertible", "Coupe"
  let uniqueName = (unique.productUniqueString || '')
    .split('|').join(', ');

  // Lloyd's code for this product unique, like 3306510
  let appCode = unique.brandApplicationCode || "";

  // FIXME snake_case
  let fieldName = cartItem.formFields().makeName('product_unique_proxy');

  // footnote, like "No embroidery on rear mats"
  let note = unique.productUniqueNote;

  return (<div>
    <label>
      <input type="radio"
        name={fieldName}
        value={appCode}
        onChange={handleChange}/>

      <span>{uniqueName}</span>

      {note &&
        <span className="block lg:inline-block font-normal ml-6 mb-4">{note}</span>}
    </label>
  </div>)
}
